



















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mask} from "vue-the-mask";

@Component({
        directives: {
            mask
        },
})
export default class Dates extends Vue {
    @Prop({default:"12"}) md!:string;

    menu: boolean = false;
    mask= "##.##.####";

    @Prop({})
    value!: Date;
    @Prop({ default: false })
    required!: boolean;


  @Watch("value")
  onValueChanged(newVal: string, oldVal: string) {
    if (newVal) {
      this.date = new Date(newVal);
      this.pickerValue = this.date.toISOString().substr(0, 10);
    } else {
      this.date = null;
      this.pickerValue = null;
    }
    this.onPickerValueChanged();
  }

    date = this.value ? new Date(this.value) : null;
    pickerValue:string|null = this.date ? this.date.toISOString().substr(0,10) : null;
    textFieldValue:string="";
    @Prop({})
    label!: string;

    lbl = this.label ? this.label : 'Tarih';


    @Watch('pickerValue')
    onPickerValueChanged(){

      this.textFieldValue = this.pickerValue ? this.formatToText(this.pickerValue) : "";

      //console.log("textFieldValue",this.textFieldValue);
            this.$emit("time",this.textFieldValue);

    }
  @Watch("textFieldValue")
  onTextFieldValueChanged() {
    if (this.textFieldValue == null || this.textFieldValue == '') {
      this.pickerValue = null;
    } else if (this.textFieldValue.length == 10) {
      this.pickerValue = this.formatToDate(this.textFieldValue);
    }
    this.save();
  }
    mounted(){
        this.onPickerValueChanged();
    }

    formatDate (date:string):string {
        if (!date) return '';

        return date.split('-').reverse().join('.');

    };

    textFieldChanged(){

        if(this.textFieldValue.length == 10){
            this.pickerValue = this.textFieldValue.split('.').reverse().join('-');
            this.save();
        }

    }

    textFieldBlur(){
        if(this.textFieldValue.length == 10){
            this.pickerValue = this.textFieldValue.split('.').reverse().join('-');
            this.save();
        }else{

            this.pickerValue = null;
            this.textFieldValue="";
            this.$emit("input",null);
        }
    }

    cancel(){
        this.menu=false;
    }

    onkeyDown(e:KeyboardEvent){
        //console.log(e);
        if(e.key == "Enter"){
            this.save();
            this.menu=false;
        }
    }
  formatToText(date: string): string {
    if (!date) return "";
    return date
        .split("-")
        .reverse()
        .join(".");
  }

  formatToDate(date: string): string {
    if (!date) return "";
    return date
        .split(".")
        .reverse()
        .join("-");
  }
  save() {
    if (this.pickerValue) {
      this.$emit("input", this.pickerValue);
    } else {
      this.$emit("input", null);
    }
    this.menu = false;
  }
};
